module.exports = __webpack_public_path__ + "img/startup-2480722_1920.b285def7.jpg";